module.exports = __webpack_public_path__ + "static/media/lifeline_step_4_neg.9ae25f9b.png";